import type { ReactNode } from 'react'
import { toSafeRuntimeHtml } from '../../../../shared/security/safeBrowserOutput'
import type { ProductFieldRuntimeResponse } from './runtime'

type Props = {
  fallback: ReactNode
  runtimeResult: ProductFieldRuntimeResponse | null
  className?: string
}

export const ProductFieldRuntimeView = ({ fallback, runtimeResult, className = '' }: Props) => {
  if (!runtimeResult || runtimeResult.ok !== true) {
    return <>{fallback}</>
  }

  return <span className={className} dangerouslySetInnerHTML={toSafeRuntimeHtml(runtimeResult.html)} />
}
